import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { Seo, breadcrumbSchema } from "../components/Seo";
import { 
  // StatsSection, Testimonials,
  SectionHeading, WhySynani, CtaSection, Ribbon 
} from "../components/Sections";
import { ABOUT_PILLARS } from "../lib/data";
import { BRAND } from "../lib/site";

const SCHEMA = breadcrumbSchema([["Home", "/"], ["About Us", "/about"]]);

export default function About() {
  return (
    <>
      <Seo
        title="About Us"
        description="SYNANI Talent Solutions is a talent solutions and staffing company helping organizations find and engage skilled professionals across IT and Non-IT domains."
        keywords="About SYNANI, Talent Solutions Company, Staffing Company Chennai, Recruitment Partner India"
        schema={SCHEMA}
      />
      <PageHeader
        kicker="About Us"
        title="A modern talent partner for a changing workforce"
        sub={`${BRAND.name} helps businesses find the right people and helps professionals find the right opportunities.`}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-testid="about-story">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal><SectionHeading kicker="Our Story" title={`About ${BRAND.name}`} /></Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-lg text-ink leading-relaxed">
                SYNANI is a talent solutions and staffing company helping organizations find and engage skilled professionals across IT and Non-IT domains.
              </p>
              <p className="mt-4 text-lg text-ink leading-relaxed">
                We combine industry understanding, human expertise, structured recruitment and technology-enabled sourcing to help businesses build the teams they need to grow.
              </p>
              <p className="mt-4 text-lg text-ink leading-relaxed">
                We work with startups, SMEs and large enterprises — building hiring partnerships that scale as their teams grow.
              </p>
            </Reveal>
            <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-8">
              {ABOUT_PILLARS.map((p, i) => (
                <Reveal key={p.title} delay={0.15 + i * 0.06}>
                  <div className="border-t border-slate-200 pt-5">
                    <span className="font-heading font-black text-2xl text-sapphire" aria-hidden="true">0{i + 1}</span>
                    <h3 className="mt-2 font-bold text-navy text-lg">{p.title}</h3>
                    <p className="mt-1.5 text-ink leading-relaxed">{p.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Ribbon />
      <WhySynani />
      {/* <StatsSection /> */}
      {/* <Testimonials /> */}
      <CtaSection />
    </>
  );
}
